import { EXTERNAL_URL, LOCAL_STORAGE_MIGRATE } from '~/constants';
import { includes, isEmpty, isNumber, localStorageManager, asyncLoadScript } from '~/utils';

// clarity 录屏 https://clarity.microsoft.com/
export const initClarity = ({
    userId,
    sessionId,
    pageId,
    beta,
    userTag,
    userRegisteredDays
}: {
    userId?: string;
    sessionId?: string;
    pageId?: string;
    beta?: boolean;
    userTag?: string;
    userRegisteredDays?: number; // corpUserStore.userRegisteredDays
}) => {
    const clarity_config = window.jdy_config.clarity;
    if (isEmpty(clarity_config)) {
        return;
    }
    // tag校验
    if (!clarity_config?.tag || !clarity_config?.enable) {
        return;
    }
    // 注册天数校验
    if (!isEmpty(clarity_config.time_range) && isNumber(userRegisteredDays)) {
        if (
            clarity_config.time_range[0]! > userRegisteredDays ||
            userRegisteredDays > clarity_config.time_range[1]!
        ) {
            return;
        }
    }
    // 页面校验
    if (!isEmpty(clarity_config.page_range) && !beta) {
        if (!includes(clarity_config.page_range, pageId)) {
            return;
        }
    }
    // 用户排除（邀请）
    if (!isEmpty(clarity_config.user_exclude)) {
        if (includes(clarity_config.user_exclude, userTag)) {
            return;
        }
    }
    // 自定义sessionId默认为user_cookie_id，用于串联注册页和应用页
    const userCookieId = localStorageManager.get(LOCAL_STORAGE_MIGRATE.USER_COOKIE_ID);
    window.clarity =
        window.clarity ||
        function () {
            (window.clarity.q = window.clarity.q || []).push(arguments);
        };
    asyncLoadScript(EXTERNAL_URL.CLARITY + clarity_config?.tag).then(() => {
        window.clarity('identify', userId, sessionId || userCookieId);
        window.clarity('set', 'pageId', pageId);
    });
};
